export default {
  methods: {
    showContentSidebar(business, contentType, content = null) {
      this.$emit('showContentSidebar', { business, contentType, content })
    }
  }
}
